import React from 'react';

export default function Leaderboard({ providers }) {
  if (!providers || providers.length === 0) {
    return <div className="text-center py-16 text-slate-500 text-sm">No providers yet.</div>;
  }

  return (
    <div className="bg-slate-900/60 border border-slate-800 rounded-xl overflow-hidden">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-slate-800 text-[10px] text-slate-500 uppercase tracking-wider">
            <th className="px-4 py-3 text-left">#</th>
            <th className="px-4 py-3 text-left">Provider</th>
            <th className="px-4 py-3 text-center">Reputation</th>
            <th className="px-4 py-3 text-center hidden md:table-cell">SLA</th>
            <th className="px-4 py-3 text-right">Calls</th>
            <th className="px-4 py-3 text-right">Price</th>
          </tr>
        </thead>
        <tbody>
          {providers.map((p, i) => (
            <tr key={i} className="border-b border-slate-800/50 hover:bg-slate-800/30 transition-colors">
              <td className="px-4 py-3 text-slate-500 font-mono">{p.rank || i + 1}</td>
              <td className="px-4 py-3">
                <div>
                  <span className="text-white font-medium">{p.name}</span>
                  <div className="flex gap-1 mt-0.5">
                    {(p.tags || []).slice(0, 3).map((tag, j) => (
                      <span key={j} className="text-[9px] text-slate-500">{tag}</span>
                    ))}
                  </div>
                </div>
              </td>
              <td className="px-4 py-3 text-center">
                <span className={`font-mono font-bold ${
                  p.reputation_active >= 80 ? 'text-emerald-400' :
                  p.reputation_active >= 60 ? 'text-blue-400' :
                  p.reputation_active >= 40 ? 'text-yellow-400' : 'text-red-400'
                }`}>
                  {p.reputation_active}
                </span>
                <span className="text-slate-600 text-xs ml-0.5">/100</span>
              </td>
              <td className="px-4 py-3 text-center hidden md:table-cell">
                <span className={`text-xs ${
                  p.sla_tier === 'Enterprise' ? 'text-purple-400' :
                  p.sla_tier === 'Professional' ? 'text-blue-400' : 'text-slate-400'
                }`}>
                  {p.sla_tier}
                </span>
              </td>
              <td className="px-4 py-3 text-right font-mono text-slate-300">
                {(p.total_calls || 0).toLocaleString()}
              </td>
              <td className="px-4 py-3 text-right font-mono text-slate-300">
                {typeof p.price_per_call === 'number' && p.price_per_call > 1
                  ? `$${(p.price_per_call / 1_000_000).toFixed(4)}`
                  : `$${p.price_per_call}`}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
